import { takeEvery, put, select } from 'redux-saga/effects'
import * as Sentry from '@sentry/browser'

import { isResponseFailed } from 'helpers/responseHelpers'
import { onBoarding } from '../actions'
import { modal } from 'store/entities/modal/actions'
import { setQueries } from 'store/entities/localSettings/actions'
import {
  saveProfile,
  subscribeToProTrack,
  updateSubscribeToProTrack,
  markLoginFlowAsFinished,
} from 'store/entities/identity/actions'
import { getQueries } from 'store/entities/localSettings/selectors'
import {
  isStageIsSelection,
  getIdentityActiveProTrackId,
  isIdentityActiveProTrackAutoEnroll,
} from 'store/entities/identity/selectors'
import { TIME_PREFERENCES_FORM } from 'app/constants/profile'
import { types } from 'app/constants/notificationType'

export default function* savePreferencesEvery() {
  yield takeEvery(onBoarding.savePreferences.toString(), handleSavePreferences)
}

export function* handleSavePreferences({ payload: { values } }) {
  let newValues = values.set('form', TIME_PREFERENCES_FORM)
  if (newValues.get('notificationType') === types.EMAIL) {
    newValues = newValues.delete('phone')
  }
  try {
    yield put(onBoarding.changeIsLoading(true))
    const saveProfileResponse = yield saveProfile.call(newValues)
    if (isResponseFailed(saveProfileResponse)) {
      throw saveProfileResponse
    }
    yield put(modal.hide())

    const queries = yield select(getQueries)
    const isAutoEnroll = yield select(isIdentityActiveProTrackAutoEnroll)
    const activeLevelId = yield select(getIdentityActiveProTrackId)
    const isSelection = yield select(isStageIsSelection)
    const proTrackLevelId = queries.get('proTrackLevelId')
    if (isAutoEnroll && activeLevelId) {
      yield put(updateSubscribeToProTrack({ proTrackLevelId, autoEnroll: false }))
    } else if (isSelection) {
      yield put(subscribeToProTrack({ proTrackLevelId }))
    }
    yield put(setQueries({ isReadyToRunTour: true }))
    yield put(markLoginFlowAsFinished())
  } catch (error) {
    if (error.status !== 422) {
      Sentry.withScope(scope => {
        scope.setExtra('where error was happen', 'handleSavePreferences saga')
        Sentry.captureException(error)
      })
    }
  } finally {
    yield put(onBoarding.changeIsLoading(false))
  }
}
